import { useState, useRef, useCallback } from 'react';
import * as config from '@config';
import { GetToken } from '@utils/storage';
import PropTypes from 'prop-types';

function useActivityOrderUpdate() {
    const [submitting, setSubmitting] = useState(false);
    const abortControllerRef = useRef(null);

    const handleUpdateUserDefined = useCallback(async (id, userDefined) => {
        setSubmitting(true);
        const req = {
            userDefined: userDefined,
        };
        abortControllerRef.current = new AbortController();
        try {
            const response = await fetch(`${config.apiURL}/order/${id}`, {
                method: 'PATCH',
                body: JSON.stringify(req),
                headers: { Authorization: `Bearer ${GetToken()}` },
                signal: abortControllerRef.current.signal,
            });
            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.error || 'An error occurred while updating user defined');
            }
            const data = await response.json();
            return data;
        } catch (error) {
            if (error.name === 'AbortError') {
                console.log('Request was aborted');
                throw new Error('Request was aborted');
            } else {
                console.error('Error updating order:', error);
            }
            throw error;
        } finally {
            setSubmitting(false);
        }
    }, []);

    handleUpdateUserDefined.propTypes = {
        id: PropTypes.number.isRequired,
        userDefined: PropTypes.string.isRequired,
    };

    const abort = useCallback(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
    }, []);

    return { submitting, handleUpdateUserDefined, abort };
}

export default useActivityOrderUpdate;
